<template>
  <div class="admin-tab" v-if="initialized">
    <v-switch v-model="companyVision" :label="`Company vision: ${companyVision ? 'on' : 'off'}`"></v-switch>
    <admin-settings></admin-settings>
    <json-editor></json-editor>
    <div class="py-5">
      Landing Page Config version: {{configVersion}}
      <br>
      <v-btn @click="upgradeModal = true">
        Upgrade to Latest version
      </v-btn>
    </div>

    <v-dialog width="600" v-model="upgradeModal">
      <v-card>
        <v-card-title class="headline">Upgrade the landing page to the latest version?</v-card-title>
        <v-card-text class="py-4">
          Upgrading to the latest version will remove the product image, product name and scan result from the landing page. <br>
          These elements can be added back manually later on.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="upgradeModal = false" text>Cancel</v-btn>
          <v-btn @click="upgradeLandingPageVersion" color="red" :disabled="upgrading" text>Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex'
import JSONEditor from '@/components/utils/JSONEditor'
import AdminSettings from '@/components/utils/AdminSettings'

export default {
  name: 'AdminTab',
  computed: {
    ...mapGetters(['initialized', 'configVersion']),
    companyVision: {
      get () {
        return this.$store.getters.companyVision
      },
      set (value) {
        this.changeCompanyVision(value)
      }
    }
  },
  components: {
    'admin-settings': AdminSettings,
    'json-editor': JSONEditor
  },
  data () {
    return {
      upgradeModal: false,
      upgrading: false
    }
  },
  methods: {
    ...mapMutations({
      changeCompanyVision: 'CHANGE_COMPANY_VISION',
      setConfigVersion: 'SET_CONFIG_VERSION'
    }),

    async upgradeLandingPageVersion () {
      this.setConfigVersion(4)
      this.$store.dispatch('saveRemoteConfig')
      this.upgradeModal = false
    }
  },
  created () {

  }
}
</script>

<style lang="sass" scoped>

@import '@/variables.sass'

.admin-tab
  padding: 20px
</style>
